var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-list"},[_vm._t("default",_vm._l((_vm.localValue),function(alert,index){return _c('alert',_vm._b({key:index},'alert',alert,false),[_c('span',{domProps:{"innerHTML":_vm._s(alert.text)}})])}))],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce6f1ca6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/AlertList.vue
// module id = 49
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17